import React, {useEffect, useMemo, useState} from "react";
import {stateApi} from "@/utils/stateApi";
import Link from "antd/es/typography/Link";
import {StateText} from "@/utils/stateChange";
import {monitorList} from "@/utils/stateApiType";
import HexaStateItem from "@/component/HexaStateItem";
import {UNIHEXA_STATE_NAME} from "@/utils/constants";
import serverData from '@/data/config.json'

function HexaStateTitle({state}: { state: number }) {

    const titleValue = useMemo(() => {
        let obj = {
            iconClass: 'text-[#3AC79D] bg-[#071813] border-systems',
            iconSvg: <img src="/img/systems-title.svg" alt="App Logo"/>,
            textTitle: StateText(1)
        }
        if (state === 0) {
            obj.iconClass = 'text-[#F55454] bg-[#F5545430] border-error'
            obj.iconSvg = <img src="/img/systems-error.svg" alt="App Logo"/>
            obj.textTitle = StateText(0)
        }

        if (state === 2) {
            obj.iconClass = 'text-[#F4B62C] bg-[#F4B62C30] border-padding'
            obj.iconSvg = <img src="/img/systems-padding.svg" alt="App Logo"/>
            obj.textTitle = StateText(2)
        }

        return obj
    }, [state])

    return <div>
        <div className={`flex justify-center mt-[40px] `}>
            <div
                className={`all-systems-operational-600 ${titleValue.iconClass} px-[54px] py-[18px]  rounded-[20px] flex items-center`}>
                {titleValue.iconSvg}
                <span className="ml-[12px] text-[24px] font-[600]">{titleValue.textTitle}</span>
            </div>
        </div>
        <div className={`flex justify-center`}>
            <div className={`text-[#FFFFFF65] mt-[34px] flex`}>
                <div className={`flex items-center`}>
                    <span className={`state-title-operational mr-[6px]`}></span>
                    System Operational
                </div>
                <div className={`flex items-center ml-[40px]`}>
                    <span className={`state-title-degraded mr-[6px]`}></span>
                    Degraded Service
                </div>
            </div>
        </div>
    </div>
}

export default function Hexa() {

    const [detail, setDetail] = useState<monitorList[]>([])

    const getStatusPage = async () => {
        const res = await stateApi.getStatusPage(UNIHEXA_STATE_NAME).then()
        const list = res.publicGroupList[0].monitorList
        const itemList = await stateApi.getStatusPageHeartbeat(UNIHEXA_STATE_NAME, 90, 1440)
        for (let i = 0; i < list.length; i++) {
            list[i].heartbeatList = itemList.heartbeatList[list[i].id]
            serverData.uniHexa.forEach(item => {
                if (list[i].name === item.name) {
                    list[i].name = item.title
                }
            })
        }
        setDetail(list)
    }

    useEffect(() => {
        getStatusPage().then()
    }, [])

    return <div className="hexa-main">
        <div className={`main-container`}>
            {/*<Link href={`https://unisat.io/`} target={`_blank`} className="flex justify-center">*/}
            <div className="flex justify-center">
                <img src="/logo/unihexa.svg" alt="App Logo"/>
            </div>
            {/*</Link>*/}
            <HexaStateTitle state={1}/>
            <div className={`mt-10 max-w-[720px] mx-auto`}>
                <div className={`text-[rgba(255,255,255,.45)] text-sm font-normal ml-6`}>Uptime over the past 90 days.
                </div>
                <div className={`mt-3 border-[2px] border-[rgba(148,27,148,0.45)] rounded-2xl bg-[#1C141E]  `}>
                    {detail.map((item, index) => (
                        <div
                            key={item.id}
                            className={`p-6 ${!index ? 'border-b-[1px] border-[rgba(255,255,255,.10)]' : ''}`}>
                            <HexaStateItem
                                key={item.id}
                                statusList={item.heartbeatList}
                                name={item.name}
                            />
                        </div>
                    ))}
                </div>
            </div>

        </div>
    </div>
}